import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Recherche from "@/pages/Recherche";
import BulkRecherche from "@/pages/BulkRecherche";
import ManuellerUpload from "@/pages/ManuellerUpload";
import GoogleMapsRecherche from "@/pages/GoogleMapsRecherche";
import Jobboersen from "@/pages/Jobboersen";
import Leads from "@/pages/Leads";
import Versand from "@/pages/Versand";
import EmailVersand from "@/pages/EmailVersand";
import Postfaecher from "@/pages/Postfaecher";
import EmailPrompts from "@/pages/EmailPrompts";
import Vorlagen from "@/pages/Vorlagen";
import KiEinstellungen from "@/pages/KiEinstellungen";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen grid place-items-center text-sm text-zinc-400">Lädt…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen grid place-items-center text-sm text-zinc-400">Lädt…</div>;
  if (user) return <Navigate to="/startupservice/recherche" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/startupservice/recherche" element={<Protected><Recherche /></Protected>} />
            <Route path="/startupservice/bulk" element={<Protected><BulkRecherche /></Protected>} />
            <Route path="/manuell/upload" element={<Protected><ManuellerUpload /></Protected>} />
            <Route path="/googlemaps" element={<Protected><GoogleMapsRecherche /></Protected>} />
            <Route path="/jobboersen" element={<Protected><Jobboersen /></Protected>} />
            <Route path="/leads" element={<Protected><Leads /></Protected>} />
            <Route path="/versand" element={<Protected><Versand /></Protected>} />
            <Route path="/email-versand" element={<Protected><EmailVersand /></Protected>} />
            <Route path="/postfaecher" element={<Protected><Postfaecher /></Protected>} />
            <Route path="/email-prompts" element={<Protected><EmailPrompts /></Protected>} />
            <Route path="/vorlagen" element={<Protected><Vorlagen /></Protected>} />
            <Route path="/ki-einstellungen" element={<Protected><KiEinstellungen /></Protected>} />
            <Route path="*" element={<Navigate to="/startupservice/recherche" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
